import * as tslib_1 from "tslib";
import { Utils } from 'cc-common';
import { Exclude, Type } from 'class-transformer';
import { TimeSubmissionResultDto } from './time-submission-result-dto';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';
import { GeneralExpenseSubmissionResultDto } from './general-expense-submission-result-dto';
import { MileageExpenseSubmissionResultDto } from './mileage-expense-submission-result-dto';
const ɵ0 = () => TimeSubmissionResultDto, ɵ1 = () => GeneralExpenseSubmissionResultDto, ɵ2 = () => MileageExpenseSubmissionResultDto, ɵ3 = () => UserNameDisplayResultDto, ɵ4 = () => Date, ɵ5 = () => Date, ɵ6 = () => Date, ɵ7 = () => UserNameDisplayResultDto, ɵ8 = () => Date, ɵ9 = () => UserNameDisplayResultDto, ɵ10 = () => Date;
export class TimeExpenseSubmissionHistoryResultDto {
    get submittedByDisplayText() {
        return Utils.notNullAndDefined(this.submittedBy) ? this.submittedBy.displayName : null;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Array)
], TimeExpenseSubmissionHistoryResultDto.prototype, "timeSubmissionItems", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Array)
], TimeExpenseSubmissionHistoryResultDto.prototype, "expenseSubmissionItems", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Array)
], TimeExpenseSubmissionHistoryResultDto.prototype, "mileageSubmissionItems", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], TimeExpenseSubmissionHistoryResultDto.prototype, "submittedBy", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", Date)
], TimeExpenseSubmissionHistoryResultDto.prototype, "submittedDate", void 0);
tslib_1.__decorate([
    Type(ɵ5),
    tslib_1.__metadata("design:type", Date)
], TimeExpenseSubmissionHistoryResultDto.prototype, "fromDate", void 0);
tslib_1.__decorate([
    Type(ɵ6),
    tslib_1.__metadata("design:type", Date)
], TimeExpenseSubmissionHistoryResultDto.prototype, "toDate", void 0);
tslib_1.__decorate([
    Type(ɵ7),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], TimeExpenseSubmissionHistoryResultDto.prototype, "verifiedBy", void 0);
tslib_1.__decorate([
    Type(ɵ8),
    tslib_1.__metadata("design:type", Date)
], TimeExpenseSubmissionHistoryResultDto.prototype, "verifiedDate", void 0);
tslib_1.__decorate([
    Type(ɵ9),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], TimeExpenseSubmissionHistoryResultDto.prototype, "approvedBy", void 0);
tslib_1.__decorate([
    Type(ɵ10),
    tslib_1.__metadata("design:type", Date)
], TimeExpenseSubmissionHistoryResultDto.prototype, "approvedDate", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", Object)
], TimeExpenseSubmissionHistoryResultDto.prototype, "selectedTab", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10 };
